'use strict';

function Dropdown() {
	let $ctrl = this;

	let setSelected = function () {
		const invalidSelectedValue = $ctrl.selectedValue?.selected?.name === '' && $ctrl.emptyDefault;
		if (invalidSelectedValue) {
			$ctrl.selectedValue.selected = { name: '--empty--', isEmpty: true };
		}

		// when "empty" option can be selected
		// values[0] might be undefined
		const addEmptyToValues = $ctrl.emptyDefault && !$ctrl.values[0]?.isEmpty;
		if (addEmptyToValues) {
			$ctrl.values.unshift({ name: '--empty--', isEmpty: true });
		}

		const foundItem = ($ctrl.values || []).find(function (x) {
			return $ctrl.compare(x, $ctrl.selectedValue.selected);
		});

		if (foundItem) {
			$ctrl.selectedValue = $ctrl.selectedValue || {};
			$ctrl.selectedValue.selected = foundItem;
		}
	};

	this.onSelected = function (selectedItem) {
		if (selectedItem) {
			let obj = angular.copy(selectedItem);
			if (selectedItem.name === '--empty--') {
				obj.name = undefined;
			}
			$ctrl.onSelectedValueChanged(obj);
		}
	};

	this.$onChanges = function () {
		setSelected();
	};
}

angular.module('PinMeTo.directives').component('pmtDropdownSearch', {
	templateUrl: 'pmtShared/directives/pmtDropDownSearch.html',
	controller: Dropdown,
	bindings: {
		placeHolder: '@',
		orderByProperty: '@',
		compare: '<',
		showValue: '<',
		values: '<',
		selectedValue: '<',
		onSelectedValueChanged: '<',
		emptyDefault: '<'
	}
});
